import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import ConfirmYourIdentityCard, {
    ConfirmYourIdentityFormData,
} from "components/card/confirm-your-identity/ConfirmYourIdentityCard";
import CardNavigationButtons from "components/card-navigation-button/CardNavigationButtons";
import { useAuthenticateResume } from "hooks/useAuthenticateResume";
import { ROUTES } from "routes/constants";

const ConfirmYourIdentityPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { authenticate, isAuthenticating, authenticationError } = useAuthenticateResume();

    // This page is only reachable through a resume link, which always carries
    // save_cont_id; direct URL access without it goes to the error page.
    const isMissingResumeContext = !searchParams.get("save_cont_id");

    useEffect(() => {
        if (isMissingResumeContext) {
            console.error("ConfirmYourIdentityPage: Missing save_cont_id");
            navigate(ROUTES.SOMETHING_WENT_WRONG, { replace: true });
        }
    }, [isMissingResumeContext, navigate]);

    const handleSubmit = async (data: ConfirmYourIdentityFormData) => {
        await authenticate(data);
    };

    const handleNext = () => {
        const form = document.getElementById("confirm-your-identity-form") as HTMLFormElement;
        if (form) {
            form.requestSubmit();
        }
    };

    if (isMissingResumeContext) return null;

    return (
        <>
            <title>Confirm Your Identity | AAA Life</title>
            <ApplicationContainer data-testid="confirm-your-identity-page">
                <div className="flex flex-col items-center gap-4">
                    <ConfirmYourIdentityCard onSubmit={handleSubmit} error={authenticationError} />
                    <CardNavigationButtons
                        className="!justify-end"
                        onNext={handleNext}
                        isLoading={isAuthenticating}
                        disabled={isAuthenticating}
                    />
                </div>
            </ApplicationContainer>
        </>
    );
};

export { ConfirmYourIdentityPage };
export default ConfirmYourIdentityPage;
